//#region node_modules/construct-style-sheets-polyfill/dist/adoptedStyleSheets.js
(function() {
	if (typeof document > "u" || "adoptedStyleSheets" in document) return;
	var e = "ShadyCSS" in window && !ShadyCSS.nativeShadow, t = document.implementation.createHTMLDocument(""), n = /* @__PURE__ */ new WeakMap(), r = typeof DOMException == "object" ? Error : DOMException, i = Object.defineProperty, a = Array.prototype.forEach, o = /@import.+?;?$/gm;
	function s(e) {
		var t = e.replace(o, "");
		return t !== e && console.warn("@import rules are not allowed here. See https://github.com/WICG/construct-stylesheets/issues/119#issuecomment-588352418"), t.trim();
	}
	function c(e) {
		return "isConnected" in e ? e.isConnected : document.contains(e);
	}
	function l(e) {
		return e.filter(function(t, n) {
			return e.indexOf(t) === n;
		});
	}
	function u(e, t) {
		return e.filter(function(e) {
			return t.indexOf(e) === -1;
		});
	}
	function d(e) {
		e.parentNode.removeChild(e);
	}
	function f(e) {
		return e.shadowRoot || n.get(e);
	}
	var p = [
		"addRule",
		"deleteRule",
		"insertRule",
		"removeRule"
	], m = CSSStyleSheet.prototype;
	m.replace = function() {
		return Promise.reject(new r("Can't call replace on non-constructed CSSStyleSheets."));
	}, m.replaceSync = function() {
		throw new r("Failed to execute 'replaceSync' on 'CSSStyleSheet': Can't call replaceSync on non-constructed CSSStyleSheets.");
	};
	function h(e) {
		return typeof e == "object" ? D.isPrototypeOf(e) || m.isPrototypeOf(e) : !1;
	}
	function g(e) {
		return typeof e == "object" ? m.isPrototypeOf(e) : !1;
	}
	var _ = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), y = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
	function x(e, t) {
		var n = document.createElement("style");
		return y.get(e).set(t, n), v.get(e).push(t), n;
	}
	function S(e, t) {
		return y.get(e).get(t);
	}
	function C(e, t) {
		y.get(e).delete(t), v.set(e, v.get(e).filter(function(e) {
			return e !== t;
		}));
	}
	function w(e, t) {
		requestAnimationFrame(function() {
			t.textContent = _.get(e).textContent, b.get(e).forEach(function(e) {
				return t.sheet[e.method].apply(t.sheet, e.args);
			});
		});
	}
	function T(e) {
		if (!_.has(e)) throw TypeError("Illegal invocation");
	}
	function E() {
		var e = this, n = document.createElement("style");
		t.body.appendChild(n), _.set(e, n), v.set(e, []), y.set(e, /* @__PURE__ */ new WeakMap()), b.set(e, []);
	}
	var D = E.prototype;
	D.replace = function(e) {
		try {
			return this.replaceSync(e), Promise.resolve(this);
		} catch (e) {
			return Promise.reject(e);
		}
	}, D.replaceSync = function(e) {
		if (T(this), typeof e == "string") {
			var t = this;
			_.get(t).textContent = s(e), b.set(t, []), v.get(t).forEach(function(e) {
				e.isConnected() && w(t, S(t, e));
			});
		}
	}, i(D, "cssRules", {
		configurable: !0,
		enumerable: !0,
		get: function() {
			return T(this), _.get(this).sheet.cssRules;
		}
	}), i(D, "media", {
		configurable: !0,
		enumerable: !0,
		get: function() {
			return T(this), _.get(this).sheet.media;
		}
	}), p.forEach(function(e) {
		D[e] = function() {
			var t = this;
			T(t);
			var n = arguments;
			b.get(t).push({
				method: e,
				args: n
			}), v.get(t).forEach(function(r) {
				if (r.isConnected()) {
					var i = S(t, r).sheet;
					i[e].apply(i, n);
				}
			});
			var r = _.get(t).sheet;
			return r[e].apply(r, n);
		};
	}), i(E, Symbol.hasInstance, {
		configurable: !0,
		value: h
	});
	var O = {
		childList: !0,
		subtree: !0
	}, k = /* @__PURE__ */ new WeakMap();
	function A(e) {
		var t = k.get(e);
		return t || (t = new z(e), k.set(e, t)), t;
	}
	function j(e) {
		i(e.prototype, "adoptedStyleSheets", {
			configurable: !0,
			enumerable: !0,
			get: function() {
				return A(this).sheets;
			},
			set: function(e) {
				A(this).update(e);
			}
		});
	}
	function M(e, t) {
		for (var n = document.createNodeIterator(e, NodeFilter.SHOW_ELEMENT, function(e) {
			return f(e) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
		}, null, !1), r = void 0; r = n.nextNode();) t(f(r));
	}
	var N = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap(), F = /* @__PURE__ */ new WeakMap();
	function I(e, t) {
		return t instanceof HTMLStyleElement && P.get(e).some(function(t) {
			return S(t, e);
		});
	}
	function L(e) {
		var t = N.get(e);
		return t instanceof Document ? t.body : t;
	}
	function R(e) {
		var t = document.createDocumentFragment(), n = P.get(e), r = F.get(e), i = L(e);
		r.disconnect(), n.forEach(function(n) {
			t.appendChild(S(n, e) || x(n, e));
		}), i.insertBefore(t, null), r.observe(i, O), n.forEach(function(t) {
			w(t, S(t, e));
		});
	}
	function z(t) {
		var n = this;
		n.sheets = [], N.set(n, t), P.set(n, []), F.set(n, new MutationObserver(function(t, r) {
			if (!document) {
				r.disconnect();
				return;
			}
			t.forEach(function(t) {
				e || a.call(t.addedNodes, function(e) {
					e instanceof Element && M(e, function(e) {
						A(e).connect();
					});
				}), a.call(t.removedNodes, function(t) {
					t instanceof Element && (I(n, t) && R(n), e || M(t, function(e) {
						A(e).disconnect();
					}));
				});
			});
		}));
	}
	if (z.prototype = {
		isConnected: function() {
			var e = N.get(this);
			return e instanceof Document ? e.readyState !== "loading" : c(e.host);
		},
		connect: function() {
			var e = L(this);
			F.get(this).observe(e, O), P.get(this).length > 0 && R(this), M(e, function(e) {
				A(e).connect();
			});
		},
		disconnect: function() {
			F.get(this).disconnect();
		},
		update: function(e) {
			var t = this, n = N.get(t) === document ? "Document" : "ShadowRoot";
			if (!Array.isArray(e)) throw TypeError("Failed to set the 'adoptedStyleSheets' property on " + n + ": Iterator getter is not callable.");
			if (!e.every(h)) throw TypeError("Failed to set the 'adoptedStyleSheets' property on " + n + ": Failed to convert value to 'CSSStyleSheet'");
			if (e.some(g)) throw TypeError("Failed to set the 'adoptedStyleSheets' property on " + n + ": Can't adopt non-constructed stylesheets");
			t.sheets = e;
			var r = P.get(t), i = l(e);
			u(r, i).forEach(function(e) {
				d(S(e, t)), C(e, t);
			}), P.set(t, i), t.isConnected() && i.length > 0 && R(t);
		}
	}, window.CSSStyleSheet = E, j(Document), "ShadowRoot" in window) {
		j(ShadowRoot);
		var B = Element.prototype, V = B.attachShadow;
		B.attachShadow = function(e) {
			var t = V.call(this, e);
			return e.mode === "closed" && n.set(this, t), t;
		};
	}
	var H = A(document);
	H.isConnected() ? H.connect() : document.addEventListener("DOMContentLoaded", H.connect.bind(H));
})();
//#endregion
//#region node_modules/element-internals-polyfill/dist/maps.js
var e = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap(), u = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap(), p = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), h = (e, t, n) => {
	e.getAttribute(t) !== n && e.setAttribute(t, n);
}, g = (e, t) => {
	e.toggleAttribute("internals-disabled", t), t ? h(e, "aria-disabled", "true") : e.removeAttribute("aria-disabled"), e.formDisabledCallback && e.formDisabledCallback.apply(e, [t]);
}, _ = (e) => {
	n.get(e).forEach((e) => {
		e.remove();
	}), n.set(e, []);
}, v = (e, t) => {
	let r = document.createElement("input");
	return r.type = "hidden", r.name = e.getAttribute("name"), e.after(r), n.get(t).push(r), r;
}, y = (e, t) => {
	if (t.length) {
		let n = Array.from(t);
		n.forEach((t) => t.addEventListener("click", e.click.bind(e)));
		let [r] = n, i = r.id;
		r.id ||= (i = `${r.htmlFor}_Label`, i), h(e, "aria-labelledby", i);
	}
}, b = (e) => {
	let t = Array.from(e.elements).filter((e) => !e.tagName.includes("-") && e.validity).map((e) => e.validity.valid), n = s.get(e) || [], i = Array.from(n).filter((e) => e.isConnected).map((e) => r.get(e).validity.valid), a = [...t, ...i].includes(!1);
	e.toggleAttribute("internals-invalid", a), e.toggleAttribute("internals-valid", !a);
}, x = (e) => {
	b(E(e.target));
}, S = (e) => {
	b(E(e.target));
}, C = (e) => {
	let t = [
		"button[type=submit]",
		"input[type=submit]",
		"button:not([type])"
	].map((e) => `${e}:not([disabled])`).map((t) => `${t}:not([form])${e.id ? `,${t}[form='${e.id}']` : ""}`).join(",");
	e.addEventListener("click", (n) => {
		if (n.target.closest(t)) {
			let t = s.get(e);
			if (e.noValidate) return;
			t.size && Array.from(t).reverse().map((e) => r.get(e).reportValidity()).includes(!1) && n.preventDefault();
		}
	});
}, w = (e) => {
	let t = s.get(e.target);
	t && t.size && t.forEach((e) => {
		e.constructor.formAssociated && e.formResetCallback && e.formResetCallback.apply(e);
	});
}, T = (e, t, n) => {
	if (t) {
		let r = s.get(t);
		if (r) r.add(e);
		else {
			let n = /* @__PURE__ */ new Set();
			n.add(e), s.set(t, n), C(t), t.addEventListener("reset", w), t.addEventListener("input", x), t.addEventListener("change", S);
		}
		a.set(t, {
			ref: e,
			internals: n
		}), e.constructor.formAssociated && e.formAssociatedCallback && setTimeout(() => {
			e.formAssociatedCallback.apply(e, [t]);
		}, 0), b(t);
	}
}, E = (e) => {
	let t = e.parentNode;
	return t && t.tagName !== "FORM" && (t = E(t)), t;
}, D = (e, t, n = DOMException) => {
	if (!e.constructor.formAssociated) throw new n(t);
}, O = (e, t, n) => {
	let i = s.get(e);
	return i && i.size && i.forEach((e) => {
		r.get(e)[n]() || (t = !1);
	}), t;
}, k = (e) => {
	let t = !1;
	if (e.constructor.formAssociated) {
		let n = r.get(e);
		n === void 0 && (e.attachInternals(), n = r.get(e), t = !0);
		let { labels: i, form: a } = n;
		y(e, i), T(e, a, n);
	}
	return t;
};
function A() {
	return typeof MutationObserver < "u";
}
//#endregion
//#region node_modules/element-internals-polyfill/dist/aom.js
var j = {
	ariaAtomic: "aria-atomic",
	ariaAutoComplete: "aria-autocomplete",
	ariaBrailleLabel: "aria-braillelabel",
	ariaBrailleRoleDescription: "aria-brailleroledescription",
	ariaBusy: "aria-busy",
	ariaChecked: "aria-checked",
	ariaColCount: "aria-colcount",
	ariaColIndex: "aria-colindex",
	ariaColIndexText: "aria-colindextext",
	ariaColSpan: "aria-colspan",
	ariaCurrent: "aria-current",
	ariaDescription: "aria-description",
	ariaDisabled: "aria-disabled",
	ariaExpanded: "aria-expanded",
	ariaHasPopup: "aria-haspopup",
	ariaHidden: "aria-hidden",
	ariaInvalid: "aria-invalid",
	ariaKeyShortcuts: "aria-keyshortcuts",
	ariaLabel: "aria-label",
	ariaLevel: "aria-level",
	ariaLive: "aria-live",
	ariaModal: "aria-modal",
	ariaMultiLine: "aria-multiline",
	ariaMultiSelectable: "aria-multiselectable",
	ariaOrientation: "aria-orientation",
	ariaPlaceholder: "aria-placeholder",
	ariaPosInSet: "aria-posinset",
	ariaPressed: "aria-pressed",
	ariaReadOnly: "aria-readonly",
	ariaRelevant: "aria-relevant",
	ariaRequired: "aria-required",
	ariaRoleDescription: "aria-roledescription",
	ariaRowCount: "aria-rowcount",
	ariaRowIndex: "aria-rowindex",
	ariaRowIndexText: "aria-rowindextext",
	ariaRowSpan: "aria-rowspan",
	ariaSelected: "aria-selected",
	ariaSetSize: "aria-setsize",
	ariaSort: "aria-sort",
	ariaValueMax: "aria-valuemax",
	ariaValueMin: "aria-valuemin",
	ariaValueNow: "aria-valuenow",
	ariaValueText: "aria-valuetext",
	role: "role"
}, M = (e, t) => {
	for (let n in j) {
		t[n] = null;
		let r = null, i = j[n];
		Object.defineProperty(t, n, {
			get() {
				return r;
			},
			set(n) {
				r = n, e.isConnected ? h(e, i, n) : l.set(e, t);
			}
		});
	}
}, N = (e, t) => {
	n.set(t, []), L.observe?.(e, I);
};
function P(e) {
	let t = r.get(e), { form: n } = t;
	T(e, n, t), y(e, t.labels);
}
var F = (e, t = !1) => {
	let n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode(e) {
		return r.has(e) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	} }), i = n.nextNode(), a = !t || e.disabled;
	for (; i;) i.formDisabledCallback && a && g(i, e.disabled), i = n.nextNode();
}, I = {
	attributes: !0,
	attributeFilter: ["disabled", "name"]
}, L = A() ? new MutationObserver((e) => {
	for (let t of e) {
		let e = t.target;
		if (t.attributeName === "disabled" && (e.constructor.formAssociated ? g(e, e.hasAttribute("disabled")) : e.localName === "fieldset" && F(e)), t.attributeName === "name" && e.constructor.formAssociated) {
			let t = r.get(e), n = c.get(e);
			t.setFormValue(n);
		}
	}
}) : {};
function R(e) {
	e.forEach((e) => {
		let { addedNodes: t, removedNodes: i } = e, a = Array.from(t), c = Array.from(i);
		a.forEach((e) => {
			if (r.has(e) && e.constructor.formAssociated && P(e), l.has(e)) {
				let t = l.get(e);
				Object.keys(j).filter((e) => t[e] !== null).forEach((n) => {
					h(e, j[n], t[n]);
				}), l.delete(e);
			}
			if (m.has(e)) {
				let t = m.get(e);
				h(e, "internals-valid", t.validity.valid.toString()), h(e, "internals-invalid", (!t.validity.valid).toString()), h(e, "aria-invalid", (!t.validity.valid).toString()), m.delete(e);
			}
			if (e.localName === "form") {
				let t = s.get(e), n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode(e) {
					return r.has(e) && e.constructor.formAssociated && !(t && t.has(e)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
				} }), i = n.nextNode();
				for (; i;) P(i), i = n.nextNode();
			}
			e.localName === "fieldset" && (L.observe?.(e, I), F(e, !0));
		}), c.forEach((e) => {
			let t = r.get(e);
			t && n.get(t) && _(t), o.has(e) && o.get(e).disconnect();
		});
	});
}
function z(e) {
	e.forEach((e) => {
		let { removedNodes: t } = e;
		t.forEach((t) => {
			let n = f.get(e.target);
			r.has(t) && k(t), n.disconnect();
		});
	});
}
var B = (e) => {
	let t = new MutationObserver(z);
	window?.ShadyDOM?.inUse && e.mode && e.host && (e = e.host), t.observe?.(e, { childList: !0 }), f.set(e, t);
};
A() && new MutationObserver(R);
var V = {
	childList: !0,
	subtree: !0
}, H = class {
	constructor() {
		this.badInput = !1, this.customError = !1, this.patternMismatch = !1, this.rangeOverflow = !1, this.rangeUnderflow = !1, this.stepMismatch = !1, this.tooLong = !1, this.tooShort = !1, this.typeMismatch = !1, this.valid = !0, this.valueMissing = !1, Object.seal(this);
	}
}, U = (e) => (e.badInput = !1, e.customError = !1, e.patternMismatch = !1, e.rangeOverflow = !1, e.rangeUnderflow = !1, e.stepMismatch = !1, e.tooLong = !1, e.tooShort = !1, e.typeMismatch = !1, e.valid = !0, e.valueMissing = !1, e), W = (e, t, n) => (e.valid = ee(t), Object.keys(t).forEach((n) => e[n] = t[n]), n && b(n), e), ee = (e) => {
	let t = !0;
	for (let n in e) n !== "valid" && e[n] !== !1 && (t = !1);
	return t;
}, G = /* @__PURE__ */ new WeakMap();
function K(e, t) {
	e.toggleAttribute(t, !0), e.part && e.part.add(t);
}
var q = class extends Set {
	static get isPolyfilled() {
		return !0;
	}
	constructor(e) {
		if (super(), !e || !e.tagName || e.tagName.indexOf("-") === -1) throw TypeError("Illegal constructor");
		G.set(this, e);
	}
	add(e) {
		if (!/^--/.test(e) || typeof e != "string") throw new DOMException(`Failed to execute 'add' on 'CustomStateSet': The specified value ${e} must start with '--'.`);
		let t = super.add(e), n = G.get(this), r = `state${e}`;
		return n.isConnected ? K(n, r) : setTimeout(() => {
			K(n, r);
		}), t;
	}
	clear() {
		for (let [e] of this.entries()) this.delete(e);
		super.clear();
	}
	delete(e) {
		let t = super.delete(e), n = G.get(this);
		return n.isConnected ? (n.toggleAttribute(`state${e}`, !1), n.part && n.part.remove(`state${e}`)) : setTimeout(() => {
			n.toggleAttribute(`state${e}`, !1), n.part && n.part.remove(`state${e}`);
		}), t;
	}
}, te = function(e, t, n, r, i) {
	if (r === "m") throw TypeError("Private method is not writable");
	if (r === "a" && !i) throw TypeError("Private accessor was defined without a setter");
	if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
	return r === "a" ? i.call(e, n) : i ? i.value = n : t.set(e, n), n;
}, J = function(e, t, n, r) {
	if (n === "a" && !r) throw TypeError("Private accessor was defined without a getter");
	if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
	return n === "m" ? r : n === "a" ? r.call(e) : r ? r.value : t.get(e);
}, Y, ne = class {
	constructor(e) {
		Y.set(this, void 0), te(this, Y, e, "f");
		for (let t = 0; t < e.length; t++) {
			let n = e[t];
			this[t] = n, n.hasAttribute("name") && (this[n.getAttribute("name")] = n);
		}
		Object.freeze(this);
	}
	get length() {
		return J(this, Y, "f").length;
	}
	[(Y = /* @__PURE__ */ new WeakMap(), Symbol.iterator)]() {
		return J(this, Y, "f")[Symbol.iterator]();
	}
	item(e) {
		return this[e] == null ? null : this[e];
	}
	namedItem(e) {
		return this[e] == null ? null : this[e];
	}
};
//#endregion
//#region node_modules/element-internals-polyfill/dist/patch-form-prototype.js
function re() {
	let e = HTMLFormElement.prototype.checkValidity;
	HTMLFormElement.prototype.checkValidity = n;
	let t = HTMLFormElement.prototype.reportValidity;
	HTMLFormElement.prototype.reportValidity = r;
	function n(...t) {
		let n = e.apply(this, t);
		return O(this, n, "checkValidity");
	}
	function r(...e) {
		let n = t.apply(this, e);
		return O(this, n, "reportValidity");
	}
	let { get: i } = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, "elements");
	Object.defineProperty(HTMLFormElement.prototype, "elements", { get(...e) {
		let t = i.call(this, ...e), n = Array.from(s.get(this) || []);
		return n.length === 0 ? t : new ne(Array.from(t).concat(n).sort((e, t) => e.compareDocumentPosition ? e.compareDocumentPosition(t) & 2 ? 1 : -1 : 0));
	} });
}
//#endregion
//#region node_modules/element-internals-polyfill/dist/element-internals.js
var X = class {
	static get isPolyfilled() {
		return !0;
	}
	constructor(n) {
		if (!n || !n.tagName || n.tagName.indexOf("-") === -1) throw TypeError("Illegal constructor");
		let i = n.getRootNode(), a = new H();
		this.states = new q(n), e.set(this, n), t.set(this, a), r.set(n, this), M(n, this), N(n, this), Object.seal(this), i instanceof DocumentFragment && B(i);
	}
	checkValidity() {
		let n = e.get(this);
		if (D(n, "Failed to execute 'checkValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate) return !0;
		let r = t.get(this);
		if (!r.valid) {
			let e = new Event("invalid", {
				bubbles: !1,
				cancelable: !0,
				composed: !1
			});
			n.dispatchEvent(e);
		}
		return r.valid;
	}
	get form() {
		let t = e.get(this);
		D(t, "Failed to read the 'form' property from 'ElementInternals': The target element is not a form-associated custom element.");
		let n;
		return t.constructor.formAssociated === !0 && (n = E(t)), n;
	}
	get labels() {
		let t = e.get(this);
		D(t, "Failed to read the 'labels' property from 'ElementInternals': The target element is not a form-associated custom element.");
		let n = t.getAttribute("id"), r = t.getRootNode();
		return r && n ? r.querySelectorAll(`[for="${n}"]`) : [];
	}
	reportValidity() {
		let t = e.get(this);
		if (D(t, "Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !this.willValidate) return !0;
		let n = this.checkValidity(), r = d.get(this);
		if (r && !t.constructor.formAssociated) throw new DOMException("Failed to execute 'reportValidity' on 'ElementInternals': The target element is not a form-associated custom element.");
		return !n && r && (t.focus(), r.focus()), n;
	}
	setFormValue(t) {
		let n = e.get(this);
		if (D(n, "Failed to execute 'setFormValue' on 'ElementInternals': The target element is not a form-associated custom element."), _(this), t != null && !(t instanceof FormData)) {
			if (n.getAttribute("name")) {
				let e = v(n, this);
				e.value = t;
			}
		} else t != null && t instanceof FormData && Array.from(t).reverse().forEach(([e, t]) => {
			if (typeof t == "string") {
				let r = v(n, this);
				r.name = e, r.value = t;
			}
		});
		c.set(n, t);
	}
	setValidity(n, r, a) {
		let o = e.get(this);
		if (D(o, "Failed to execute 'setValidity' on 'ElementInternals': The target element is not a form-associated custom element."), !n) throw TypeError("Failed to execute 'setValidity' on 'ElementInternals': 1 argument required, but only 0 present.");
		d.set(this, a);
		let s = t.get(this), c = {};
		for (let e in n) c[e] = n[e];
		Object.keys(c).length === 0 && U(s);
		let l = {
			...s,
			...c
		};
		delete l.valid;
		let { valid: u } = W(s, l, this.form);
		if (!u && !r) throw new DOMException("Failed to execute 'setValidity' on 'ElementInternals': The second argument should not be empty if one or more flags in the first argument are true.");
		i.set(this, u ? "" : r), o.isConnected ? (o.toggleAttribute("internals-invalid", !u), o.toggleAttribute("internals-valid", u), h(o, "aria-invalid", `${!u}`)) : m.set(o, this);
	}
	get shadowRoot() {
		let t = e.get(this);
		return u.get(t) || null;
	}
	get validationMessage() {
		return D(e.get(this), "Failed to read the 'validationMessage' property from 'ElementInternals': The target element is not a form-associated custom element."), i.get(this);
	}
	get validity() {
		return D(e.get(this), "Failed to read the 'validity' property from 'ElementInternals': The target element is not a form-associated custom element."), t.get(this);
	}
	get willValidate() {
		let t = e.get(this);
		return D(t, "Failed to read the 'willValidate' property from 'ElementInternals': The target element is not a form-associated custom element."), !(t.matches(":disabled") || t.disabled || t.hasAttribute("disabled") || t.hasAttribute("readonly"));
	}
};
function ie() {
	if (typeof window > "u" || !window.ElementInternals || !HTMLElement.prototype.attachInternals) return !1;
	class e extends HTMLElement {
		constructor() {
			super(), this.internals = this.attachInternals();
		}
	}
	let t = `element-internals-feature-detection-${Math.random().toString(36).replace(/[^a-z]+/g, "")}`;
	customElements.define(t, e);
	let n = new e();
	return [
		"shadowRoot",
		"form",
		"willValidate",
		"validity",
		"validationMessage",
		"labels",
		"setFormValue",
		"setValidity",
		"checkValidity",
		"reportValidity"
	].every((e) => e in n.internals);
}
var Z = !1, Q = !1;
function $(e) {
	Q || (Q = !0, window.CustomStateSet = q, e && (HTMLElement.prototype.attachInternals = function(...t) {
		let n = e.call(this, t);
		return n.states = new q(this), n;
	}));
}
function ae(e = !0) {
	let t = !1;
	if (!Z) {
		if (Z = !0, typeof window < "u" && (window.ElementInternals = X), typeof CustomElementRegistry < "u") {
			let e = CustomElementRegistry.prototype.define;
			CustomElementRegistry.prototype.define = function(n, r, i) {
				if (r.formAssociated) {
					let e = r.prototype.connectedCallback;
					r.prototype.connectedCallback = function() {
						p.has(this) || (p.set(this, !0), this.hasAttribute("disabled") && g(this, !0)), e?.apply(this), t = k(this);
					};
				}
				e.call(this, n, r, i);
			};
		}
		if (typeof HTMLElement < "u" && (HTMLElement.prototype.attachInternals = function() {
			if (!this.tagName) return {};
			if (this.tagName.indexOf("-") === -1) throw Error("Failed to execute 'attachInternals' on 'HTMLElement': Unable to attach ElementInternals to non-custom elements.");
			if (r.has(this) && !t) throw new DOMException("DOMException: Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.");
			return new X(this);
		}), typeof Element < "u") {
			function e(...e) {
				let n = t.apply(this, e);
				if (u.set(this, n), A()) {
					let e = new MutationObserver(R);
					window.ShadyDOM ? e.observe(this, V) : e.observe(n, V), o.set(this, e);
				}
				return n;
			}
			let t = Element.prototype.attachShadow;
			Element.prototype.attachShadow = e;
		}
		A() && typeof document < "u" && new MutationObserver(R).observe(document.documentElement, V), typeof HTMLFormElement < "u" && re(), (e || typeof window < "u" && !window.CustomStateSet) && $();
	}
}
//#endregion
//#region node_modules/element-internals-polyfill/dist/index.js
customElements.polyfillWrapFlushCallback || (ie() ? typeof window < "u" && !window.CustomStateSet && $(HTMLElement.prototype.attachInternals) : ae(!1));
//#endregion
